var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1223_2931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.88277 10.507C8.17557 10.507 10.5228 6.94981 10.5228 3.86693C10.5228 3.7653 10.5228 3.66367 10.518 3.56687C10.9729 3.23778 11.3698 2.8264 11.6843 2.35695C11.2681 2.54086 10.818 2.66669 10.3437 2.72477C10.8277 2.43439 11.1955 1.97946 11.3698 1.43257C10.9197 1.69876 10.4212 1.89234 9.88882 1.99882C9.46292 1.54389 8.85796 1.26318 8.18525 1.26318C6.89789 1.26318 5.85252 2.30856 5.85252 3.59591C5.85252 3.77982 5.87188 3.95889 5.91543 4.12828C3.97472 4.03148 2.25663 3.10226 1.10479 1.68908C0.90636 2.03269 0.790207 2.43439 0.790207 2.86028C0.790207 3.66851 1.20158 4.38478 1.83074 4.80099C1.4484 4.79131 1.09027 4.68484 0.775688 4.51061C0.775688 4.52029 0.775688 4.52997 0.775688 4.53965C0.775688 5.67214 1.57908 6.61104 2.64865 6.82882C2.45506 6.88206 2.24695 6.9111 2.03401 6.9111C1.88398 6.9111 1.73879 6.89658 1.5936 6.86754C1.88882 7.79676 2.75028 8.46948 3.77145 8.48883C2.97291 9.11315 1.96625 9.48581 0.872482 9.48581C0.683734 9.48581 0.499826 9.47613 0.315918 9.45193C1.33709 10.1198 2.56637 10.507 3.88277 10.507Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1223_2931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3684,
    height: 11.3684,
    fill: "white",
    transform: "translate(0.315918 0.315796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b8ae51db2a74055348f8a016eb331a74.svg";
export { ForwardRef as ReactComponent };